import { graphql, useStaticQuery } from "gatsby";

// Every explainer page, Markdown and Prismic together, in navigation order.
// The same merge as gatsby-node.js, for places that sit outside the explainer
// templates (homepage, footer).
export const useGuideLinks = () => {
  const data = useStaticQuery(graphql`
    {
      allFile(
        filter: {
          sourceInstanceName: { eq: "explainers" }
          extension: { eq: "md" }
        }
      ) {
        nodes {
          name
          childMarkdownRemark {
            frontmatter {
              title
              navLabel
              navOrder
            }
          }
        }
      }
      allPrismicSchengenInfoSection {
        nodes {
          uid
          data {
            page_heading
            table_of_contents_heading
            table_of_contents_order
          }
        }
      }
    }
  `);

  const markdownGuides = data.allFile.nodes.map((file) => ({
    slug: file.name,
    title: file.childMarkdownRemark.frontmatter.title,
    label: file.childMarkdownRemark.frontmatter.navLabel,
    order: file.childMarkdownRemark.frontmatter.navOrder,
  }));
  const markdownSlugs = new Set(markdownGuides.map((guide) => guide.slug));

  const prismicGuides = data.allPrismicSchengenInfoSection.nodes
    .filter((node) => !markdownSlugs.has(node.uid))
    .map((node) => ({
      slug: node.uid,
      title: node.data.page_heading,
      label: node.data.table_of_contents_heading,
      order: node.data.table_of_contents_order,
    }));

  return [...markdownGuides, ...prismicGuides].sort(
    (a, b) => (a.order ?? 999) - (b.order ?? 999)
  );
};
